import PubSub from 'pubsub-js';

import 'core-js/fn/object/assign';
import '../lib/window-events';
import objectFitImages from 'object-fit-images';
import 'slick-carousel';

import { load } from '../sections';
import '../sections/announcement-bar';
import '../sections/modal';
import { throttle } from 'lodash';

function checkMobile() {
  return window.matchMedia('(max-width: 991px)').matches;
}

let isMobile = checkMobile();

window.addEventListener('resize', throttle(function () {

  if (isMobile != checkMobile()) {
    isMobile = checkMobile();

    window.PubSub.publish('window:mobile-state-change');
  }
}, 50));

function toggles() {
  $('[data-toggle-target]').on('click', function (e) {
    e.preventDefault();

    let $target = $(this.dataset.toggleTarget);

    $target.stop().slideToggle(150);

    this.classList.toggle('active')

    if (this.dataset.ariaLabelActive && this.dataset.ariaLabelInactive) {
      let label = this.classList.contains('active')
        ? this.dataset.ariaLabelActive
        : this.dataset.ariaLabelInactive

      this.setAttribute('aria-label', label)
    }
  });
}

window.PubSub.subscribe('window:mobile-state-change', function () {
  console.log('state changed')
  $('.header-search-toggle').removeClass('active');
  document.body.classList.remove('nav-open');
  document.querySelector('[data-search-bar]').style.display = 'none';
})

function mobileToggles() {
  let isMobile = checkMobile();

  $(document).on('click', '#menu-primary-navigation .menu-item a[href="#"], .menu-item-subnav-toggle', function (e) {
    e.preventDefault();

    $(this).toggleClass('toggle-open');
    $(this).parent().parent().toggleClass('sub-nav__open');
    $(this).parent().next('.sub-menu__wrapper').stop().slideToggle(150);
  });

  PubSub.subscribe('window:resize', function () {
    let current = checkMobile();


    if (isMobile != current) {
      isMobile = current;

      $('.sub-menu__wrapper').prop('style', false);
    }
  });
}

function anchorLinks() {
  $(document).on('click', '[href^="#"]', function (e) {
    let $this = $(this);

    if ($this.attr('href') == '#') {
      e.preventDefault();

      return false;
    }

    let $target = $($this.attr('href'));

    if ($target.length > 0) {
      e.preventDefault();

      let scrollTop = Math.max($target.offset().top - 150, 0);

      $('html, body').animate({ scrollTop }, 250);

      return;
    }
  });
}

function carousels() {
  $('.has-slider-on-mobile .row').each(function () {
    let args = {
      mobileFirst: true,
      arrows: true,
      centerMode: true,
      slidesToShow: 1,
      infinite: false,
      responsive: [{
        breakpoint: 768,
        settings: 'unslick',
      }],
    };

    $(this).slick(args);

    PubSub.subscribe('window:resize', (name, { width }) => {
      if (width <= 768) {
        return;
      }

      if (!$(this)[0].slick || $(this)[0].slick.unslicked) {
        $(this).slick(args);
      }
    });
  })

  $('.tiles .has-slider-on-mobile .row').each(function () {
    $(this).slick('unslick');
  });

  $('.slick-carousel').each(function () {
    let $this = $(this);
    let args = {
      infinite: false,
      adaptiveHeight: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
    };

    $this.slick(args);

    $this.on('swipe', event => {
      event.preventDefault();
    });
  });

  $('.testimonial-slider').each(function () {
    let $this = $(this);
    let args = {
      infinite: false,
      adaptiveHeight: true,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      dots: false,
    };

    $this.slick(args);

    $this.on('swipe', event => {
      event.preventDefault();
    });
  });
}

function clearFilters() {
  $("#clear-filters").on('click', function () {

    $('.filter input:checkbox').removeAttr('checked');

    var url = window.location.href;

    if (url.indexOf("?") != -1)
      url = url.split("?")[0];

    window.location.href = url;

  });
}

export default {
  init() {
    load('*');

    $('.nav-toggle').on('click', e => {
      e.preventDefault();

      document.body.classList.toggle('nav-open');
    });

    anchorLinks();
    mobileToggles();
    objectFitImages();
    carousels();
    toggles();
    clearFilters();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js